import { Action } from 'src/utils/reduxUtils'
import { TeamState } from './types'
import {
  FetchTeamMemberInvitesCount,
  FetchTeamMembersCount,
  FetchTeamPermissions,
  FetchTeamRoles,
} from 'src/constants/actionTypes'

const getInitialState = (): TeamState => ({
  teamMembersCount: null,
  teamRoles: null,
  teamPermissions: null,
  teamMemberInvitesCount: null,
})

export const teamReducer = (
  state: TeamState = getInitialState(),
  action: Action<any>,
): TeamState => {
  switch (action.type) {
    case FetchTeamRoles.type.SUCCESS:
      return {
        ...state,
        teamRoles: action.payload,
      }
    case FetchTeamPermissions.type.SUCCESS:
      return {
        ...state,
        teamPermissions: action.payload,
      }
    case FetchTeamMembersCount.type.SUCCESS:
      return {
        ...state,
        teamMembersCount: action.payload.total,
      }
    case FetchTeamMemberInvitesCount.type.SUCCESS:
      return {
        ...state,
        teamMemberInvitesCount: action.payload.total,
      }
    default:
      return state
  }
}
